CustomTC.define('modules/search/search',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'text!modules/htmls/loading.html', 'text!modules/search/htmls/search.html', 'css!modules/css/loading', 'css!modules/search/css/search'], function(util, core, config, constants, options, loadData, language, loading, search) {
    return {
        //init
        init: function(playerUI, video) {
            this.playerUI = playerUI;
            this.initializeSearch();
        },
        initializeSearch: function() {
            var self = this;
            self.video = options.videoInfo[0];
            // add chat username container
            var searchWrapper = core.init(search);
            core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(searchWrapper);

            // show hide search
            var searchIcon = core.init('.' + constants.CSS_TOUCHCAST_ICON_SEARCH + '');
            var searchWrapper = core.init('.' + constants.CSS_TOUCHCAST_WRAPPER_SEARCH + '');
            var searchCloseIcon = core.init('.' + constants.CSS_TOUCHCAST_ICON_SEARCH_CLOSE + '');
            var searchOverlay = core.init('.' + constants.CSS_TOUCHCAST_OVERLAY_SEARCH + '');
            var searchFrame = core.init('#' + constants.CSS_TOUCHCAST_ID_FRAME_SEARCH + '');
            var vPlayerEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
            core.setAttr(searchFrame, 'src', 'search.html?hls=' + self.video)
            core.off(searchIcon, 'touchstart click');
            core.on(searchIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.hide(searchIcon);
                core.show(searchWrapper);
                core.show(searchOverlay);
                core.show(searchCloseIcon);
                core.addClass(vPlayerEle, constants.CSS_TOUCHCAST_VIDEO_BLUR);
                document.getElementById('search-frame').contentDocument.getElementById('txtSearch').focus();
                return false;
            });
            core.off(searchCloseIcon, 'touchstart click');
            core.on(searchCloseIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.show(searchIcon);
                core.hide(searchWrapper);
                core.hide(searchOverlay);
                core.hide(searchCloseIcon);
                core.removeClass(vPlayerEle, constants.CSS_TOUCHCAST_VIDEO_BLUR);
                return false;
            });
            core.off(searchOverlay, 'touchstart click');
            core.on(searchOverlay, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                core.show(searchIcon);
                core.hide(searchWrapper);
                core.hide(searchOverlay);
                core.hide(searchCloseIcon);
                core.removeClass(vPlayerEle, constants.CSS_TOUCHCAST_VIDEO_BLUR);
                return false;
            });
            this.playerUI._resizeSearch();
        }

    }
});
